import type { TableColumn } from "@kyan/ui";
import { cn } from "@kyan/ui";
import moment from "moment";

import { getPerpConstraints } from "#/config/orders";
import { UnderlyingSymbol } from "#/types/markets";
import { formatCurrency } from "#/utils/valueFormatters";

import { SizeDisplay } from "../SizeDisplay/SizeDisplay";
import type { LastTradesTableEntry } from "./LastTradesTable.types";

export const getColumns = (
  underlying: UnderlyingSymbol | "",
  isOptions: boolean,
): TableColumn<LastTradesTableEntry>[] => [
  {
    id: "price",
    header: "Price",
    cell: (row) => <>{formatCurrency(row.price)}</>,
    columnClassName: cn({
      "sm:text-xxs py-0.5 pl-1": !isOptions,
      "py-1 pl-2": isOptions,
    }),
    cellClassName: cn({
      "pl-1": !isOptions,
      "pl-2": isOptions,
    }),
  },
  {
    id: "size",
    header: "Size",
    cell: (row) => {
      if (!underlying) return "";

      const { sizeDisplayPrecision } = getPerpConstraints(underlying);

      return (
        <SizeDisplay
          value={row.size}
          underlying={underlying}
          precision={sizeDisplayPrecision}
        />
      );
    },
    columnClassName: cn("ml-auto", {
      "sm:text-xxs py-0.5": !isOptions,
      "py-1": isOptions,
    }),
    cellClassName: "text-textSecondary ml-auto",
    minWidth: "80px",
    maxWidth: "120px",
  },
  {
    id: "time",
    header: "Time",
    cell: (row) => <>{moment(row.time).format("HH:mm, DD MMM")}</>,
    columnClassName: cn("ml-auto", {
      "sm:text-xxs py-0.5 pr-2": !isOptions,
      "py-1 pr-3": isOptions,
    }),
    cellClassName: cn("text-textSecondary ml-auto", {
      "pr-2": !isOptions,
      "pr-3": isOptions,
    }),
    minWidth: "80px",
    maxWidth: "120px",
  },
];
